<template>
  <div class="container">
    <div class="breadcrumb flex-fs">
      <div class="content">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>课程详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="content coursesDetails">
      <div class="caption flex-sb">
        {{ data.course && data.course.courseTitle }}
        <p>
          点击学习下列知识点，查看对应的培训课程，学完所有课程方可增加
          该知识点对应的学时
        </p>
      </div>
      <div class="flex-fs">
        <div class="vedio">
          <video-player
            @ended="onPlayerEnd($event)"
            @timeupdate="onPlayerPlaying($event)"
            class="video-player-box"
            :class="{ studyState: openVedioInfo.studyState == 1 }"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
          >
          </video-player>
        </div>
        <div class="right">
          <div class="lecturer flex-fs">
            <div class="avatar">
              <img src="" alt="" />
            </div>
            <div>讲师: 张三</div>
            <div class="star" @click="cancelCollect" v-if="collectStatus">
              <i style="color: rgb(255, 186, 66)" class="el-icon-star-on"></i>
              已收藏
            </div>
            <div v-else class="star" @click="requestCollect">
              <i class="el-icon-star-off"></i>
              收藏
            </div>
          </div>
          <div class="tabBar flex-fs">
            <div
              @click="swicthTab(1)"
              class="flex-cc"
              :class="{ current: tabActive == 1 }"
            >
              <i class="el-icon-discover"></i> <span>课程信息</span>
            </div>
            <div
              @click="swicthTab(2)"
              :class="{ current: tabActive == 2 }"
              class="flex-cc"
            >
              <i class="el-icon-s-operation"></i> <span>目录</span>
            </div>
          </div>
          <div class="courseInfo" v-if="tabActive == 1">
            <div class="des" :class="{ current: true }">
              {{ data.course && data.course.courseSynopsis }}
            </div>
          </div>
          <div class="courseInfo" v-else>
            <template v-for="item in handleTreeList">
              <div class="chapter">
                {{ item.infoTitle }}
              </div>
              <div class="chapter-content" v-if="item.children.length > 0">
                <div
                  class="sub"
                  @click="switchViewVedio(sonItem)"
                  :class="{ current: openVedioInfo.infoId == sonItem.infoId }"
                  v-for="sonItem in item.children"
                >
                  <div style="width: 300px;">{{ sonItem.infoTitle }}</div>
                  <div class="flex-fs" style="width: 185px">
                    <div class="progess">
                      <el-progress
                        class="pro"
                        :percentage="
                          progess(sonItem.studyTime, sonItem.infoTime)
                        "
                      ></el-progress>
                    </div>
                    <span>{{
                      sonItem.studyState == 2
                        ? "已学习"
                        : sonItem.studyState == 1
                        ? "学习中"
                        : "未学习"
                    }}</span>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { handleTree } from "@/utils/handleTree";
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import { myCourseDetails, courseOpen, collect, getCollectIds } from "@/api";
import { Loading } from "element-ui";

export default {
  name: "CoursesDetails",
  components: {
    videoPlayer,
  },
  data() {
    return {
      playerOptions: {
        playbackRates: false, // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时立即开始播放,为false则点击才播放
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "15:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。
        // 值应该代表一个比例 '视频屏幕高度:视频屏幕宽度' - 用冒号分隔的两个数字（例如"16:9"或"4:3",'14:10'）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", //文件类型
            src: "", // url地址
          },
        ],
        poster: "", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: false, // 显示持续时间
          remainingTimeDisplay: true, // 是否显示剩余时间功能
          fullscreenToggle: false, // 是否显示全屏按钮
        },
      },

      ucId: 0,
      tabActive: 2,
      data: {
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        remark: null,
        courseTitle: "",
        courseType: "",
        courseMajor: "",
        coursePic: "",
        courseSynopsis: "",
        courseTime: "",
        courseScore: "",
        courseClick: "",
        courseInfoList: [],
      },
      handleTreeList: [],
      openVedioInfo: {
        infoId: 0,
        studyState: 1,
      },

      collectArr: [],
      collectStatus: false,
      loading: false,
      endTime: 0,
      ////
      pageId: null, // 当前页面的唯一标识
      visibilityChangeHandler: null, // 用于存储事件监听器，以便销毁
    };
  },

  mounted() {
    this.repeatPage();
    this.ucId = this.$route.query.ucId;
    this.getDetails(this.$route.query.ucId);

    window.addEventListener("beforeunload", (event) => {
     // event.preventDefault();
      // 自定义消息
      this.cleanupMarker();

    });
    if (localStorage.getItem("collectArr")) {
      this.collectArr = JSON.parse(localStorage.getItem("collectArr"));
    }
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.cleanupMarker);
    this.cleanupMarker();
  },
  methods: {
    repeatPage() {
      this.pageId = Math.random().toString(36).substr(2, 9);
      // 检查是否已有播放页面打开
      const existingPageId = localStorage.getItem("unique_playing_page");
      if (existingPageId && existingPageId !== "null") {
        // 如果已经有播放页面打开，且不是自己，则提示并关闭当前页面
        this.$notify({
          title: "提示",
          message: "只能在一个窗口观看课程视频",
          type: "warning",
        });

        setTimeout(() => {
          localStorage.setItem("repeat_unique_playing_page",true);
          location.href = "/";
        }, 1000);
        return;
      } else {
        localStorage.setItem("unique_playing_page", this.pageId);
      }
    },

    cleanupMarker() {
      localStorage.setItem("unique_playing_page", null);
    },
    requestCollect() {
      collect({ courseId: this.data.courseId }).then((res) => {
        if (res.code == 200) {
          getCollectIds().then((res) => {
            this.collectArr = res.data;
            localStorage.setItem("collectArr", JSON.stringify(res.data));
          });
          this.collectStatus = true;
        }
      });
    },
    cancelCollect() {
      axios
        .delete(
          `${process.env.VUE_APP_BASE_URL}/prod-api/web/collect/${this.data.courseId}`,
          {
            headers: {
              Authorization: localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.collectStatus = false;
            getCollectIds().then((res) => {
              this.collectArr = res.data;
              localStorage.setItem("collectArr", JSON.stringify(res.data));
            });
          }
        });
    },

    switchViewVedio(data) {
      this.openVedioInfo = data;
      this.playerOptions.sources[0].src = data.infoVideo;
      if (data.studyState != 2) {
        setTimeout(() => {
          const player = this.$refs.videoPlayer.player;
          player.currentTime(data.studyTime); // 单位为秒
        }, 500);
      }
    },
    swicthTab(val) {
      this.tabActive = val;
    },
    secondsToTime(seconds) {
      const hours = Math.floor(seconds / 3600); // 计算小时数
      const minutes = Math.floor((seconds % 3600) / 60); // 计算分钟数
      const remainingSeconds = seconds % 60; // 计算剩余的秒数
      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
    },
    getDetails(courseId) {
      let loadingInstance = Loading.service({ fullscreen: true });
      myCourseDetails(courseId)
        .then((res) => {
          if (res.code == 200) {
            this.handleTreeList = handleTree(
              res.data.courseInfoList,
              "infoId",
              "parentId"
            );

            this.data = res.data;
            this.collectStatus =
              this.collectArr.indexOf(res.data.courseId) != -1 ? true : false;
            this.playerOptions.poster =
              `${process.env.VUE_APP_BASE_URL}/prod-api` +
              res.data.course.coursePic;
            let progess = true;
           outerLoop: for (let i = 0; i < this.handleTreeList.length; i++) {
              for (let s = 0; s < this.handleTreeList[i].children.length; s++) {
                if (this.handleTreeList[i].children[s].studyState != 2) {
                  console.log('xxxxxxxxx')
                  progess = false;
                  this.openVedioInfo = this.handleTreeList[i].children[s];
                  this.playerOptions.sources[0].src =
                    this.handleTreeList[i].children[s].infoVideo;
                  if (this.openVedioInfo.studyState != 2) {
                    setTimeout(() => {
                      const player = this.$refs.videoPlayer.player;
                      player.currentTime(this.openVedioInfo.studyTime); // 单位为秒
                    }, 500);
                  }
                  break outerLoop;
                }
              }
            }

            if (
              progess &&
              this.handleTreeList.length > 0 &&
              this.handleTreeList[0].children.length > 0 &&
              this.handleTreeList[0].children[0].infoVideo
            ) {
              this.openVedioInfo = this.handleTreeList[0].children[0];
              this.playerOptions.sources[0].src =
                this.handleTreeList[0].children[0].infoVideo;
            }
          }
        })
        .finally(() => {
          loadingInstance.close();
        });
    },
    requestCourseOpen(studyTime, end = false) {
      if (this.openVedioInfo.studyState == 2 || this.loading) {
        //已完成不需要请求
        return;
      }
      this.loading = true;
      courseOpen({
        ucId: this.ucId,
        infoId: this.openVedioInfo.infoId,
        studyTime,
      })
        .then((res) => {
          if (res.code == 200) {
            console.log("结束", end);
            if (end) {
              this.getDetails(this.$route.query.ucId);
            }
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 2000);
        });
    },
    progess(studyTime, courseTime, symbol = false) {
      if (studyTime == 0) {
        return 0;
      }
      let key = `${((studyTime / courseTime) * 100).toFixed(0)}${
        symbol ? "%" : ""
      }`;
      return Number(key);
    },
    onPlayerEnd(player) {
      const currentTime = player.currentTime(); // 获取当前播放时间（秒）
      this.loading = false;
      this.requestCourseOpen(Math.ceil(currentTime), "end");
    },
    onPlayerPlaying(player) {
      const currentTime = player.currentTime(); // 获取当前播放时间（秒）

      if (
        currentTime > 0 &&
        Math.ceil(currentTime) % 20 == 0 &&
        !this.loading
      ) {
        this.requestCourseOpen(Math.ceil(currentTime));
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .video-js .vjs-big-play-button {
  height: 2em;
  width: 2em;
  line-height: 2em;
  border-radius: 1em;
  background: rgba(#fff, #fff, #fff, 0.5);
  left: 50%;
  top: 50%;
  margin-left: -1em;
  margin-top: -1rem;
}
.container {
  background: #f8fbff;
  .breadcrumb {
    height: 40px;
    line-height: 40px;
    background: #e3eefb;
    font-size: 14px;
    color: #939393;
  }
  .coursesDetails {
    padding-bottom: 160px;
    .caption {
      position: relative;
      height: 84px;
      font-size: 26px;
      p {
        color: #1265cc;
        font-size: 16px;
        position: absolute;
        bottom: 18px;
        right: 0;
      }
    }

    //
    .vedio {
      width: 1040px;
      height: 640px;

      /deep/.video-player-box.studyState {
        height: 640px;
        .vjs-progress-control {
          pointer-events: none !important;
        }
        // .vjs-control-bar {
        //   display: none !important;
        // }
      }
    }
    .right {
      width: calc(100% - 1040px);
      height: 640px;
      .lecturer {
        position: relative;
        height: 72px;
        background: #1265cc;
        color: #fff;
        .avatar {
          margin-left: 40px;
          margin-right: 20px;
          height: 50px;
          width: 50px;
          border-radius: 25px;
          img {
            width: 100%;
          }
        }

        .star {
          position: absolute;
          right: 30px;
          bottom: 22px;
          cursor: pointer;
        }
      }

      .tabBar {
        height: 65px;
        background: #f7f7f7;
        font-size: 16px;
        padding-left: 72px;
        border: 2px solid #eeeeee;
        border-top: 0;
        div {
          width: 120px;
          color: #666666;
          height: 34px;
          cursor: pointer;
          margin-right: 30px;
          border-radius: 50px;
          background: #fff;
          &.current {
            background: #1265cc;
            color: #fff;
            span {
              padding-left: 2px;
            }
            i {
              color: #fff;
            }
          }
        }
      }

      //
      .courseInfo {
        padding-left: 36px;
        padding-right: 22px;
        height: 500px;
        border-left: 2px solid #eeeeee;
        border-right: 1px solid #eee;
        border-bottom: 1px solid #eee;
        overflow-y: scroll;
        .des {
          padding-top: 10px;
          line-height: 25px;
          text-indent: 2ch;
        }
        .chapter {
          font-size: 16px;
          margin-bottom: 22px;
          margin-top: 18px;
          cursor: pointer;
          &.current {
            color: #1265cc;
          }
        }
        .chapter-content {
          font-size: 14px;
          padding-left: 65px;
          position: relative;
          &::before {
            content: "";
            border-left: 1px dashed #ddd;
            top: 8px;
            left: 54px;
            bottom: 8px;
            position: absolute;
          }
          & > div {
            cursor: pointer;
            position: relative;
            padding: 10px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &.sub::after {
              content: "";
              width: 8px;
              height: 8px;
              border: 1px solid #666;
              border-radius: 10px;
              position: absolute;
              left: -16px;
              top: 50%;
              margin-top: -4px;
            }
            .progess {
              .pro {
                width: 100px;
              }
            }
          }
          .current {
            color: #1265cc;
            span {
            }
          }
        }
      }
    }
  }
}
</style>
